import { ExternalEnum } from '@enums/route-enum';
import { getCtaHref } from '@enums/campaign-enum';
import LandingFooter from '@components/landing-footer';

export default {
  name: 'main-layout',
  components: { LandingFooter },
  data() {
    return {
      companyParam: null,
    };
  },
  computed: {
    getHeaderClass() {
      return this.companyParam ? 'ld-landing-header--partner' : 'ld-landing-header--main';
    },
    headerData() {
      if (this.$route && this.$route.params && this.$route.params.company) {
        this.companyParam = this.$route.params.company;
      }

      return {
        logoHref: './',
        cta: {
          key: 'get-started',
          value: this.$t('common.header.get_started'),
          href: getCtaHref(this.companyParam),
          target: '_blank',
        },
        options: [
          {
            key: 'home',
            value: this.$t('common.header.home'),
            href: '#',
          },
          {
            key: 'how-it-works',
            value: this.$t('common.header.how_it_works'),
            href: '#how-it-works',
          },
          {
            key: 'about-us',
            value: this.$t('common.header.about_us'),
            href: '#about-us',
          },
          {
            key: 'calculators',
            value: this.$t('common.header.calculators'),
            href: ExternalEnum.CALCULATORS.href,
            target: '_blank',
          },
          {
            key: 'blog',
            value: this.$t('common.header.blog'),
            href: ExternalEnum.BLOG.href,
            target: '_blank',
          },
          {
            key: 'contact-us',
            value: this.$t('common.header.contact'),
            href: '#contact-us',
          },
        ],
        extraOptions: [
          {
            key: 'log-in',
            value: this.$t('common.header.login'),
            href: ExternalEnum.LOGIN.href,
            target: '_blank',
          },
        ],
        partnerSrc: this.companyParam ? '' : `${this.$cdnUrl}/images/landing-page/sg_logo.png`,
      };
    },
  },
};
